import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useStyles } from './Searchbar.styles';
import InputBase from '@material-ui/core/InputBase';
import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';
import _ from 'lodash';
import { IconButton } from '@material-ui/core';
import { useTabNavigationDetails } from '../../Context/TabNavigation.context';
import { useLayoutContext } from '../../Context/Layout.context';
import TooltipOne from '../TooltipOne/TooltipOne.component';
import { fill } from '../../utils/contrastSvgAttributes';

interface SearchbarProps {
  handleSearchInput: (name: string, value: string) => void;
  name: string;
  searchInput: string;
  key?: string;
  noBorder?: boolean;
  tabIndex?: number;
}

export const Searchbar: React.FC<SearchbarProps> = (props) => {
  const classes = useStyles();
  const inputRef = useRef<HTMLInputElement | null>(null);
  const { tabIndexForChildren } = useTabNavigationDetails();

  const { highContrastMode } = useLayoutContext();

  const [localInput, setLocalInput] = useState<string>(props.searchInput);
  const [isReadOnly, setIsReadOnly] = useState<boolean>(true);

  useEffect(() => {
    setLocalInput(props.searchInput);
  }, [props.key, props.searchInput]);

  const updateExternalInput = useCallback(
    _.debounce((value: string) => {
      props.handleSearchInput(props.name, value);
    }, 500),
    [props.name, props.handleSearchInput],
  );

  useEffect(() => {
    updateExternalInput(localInput);
  }, [localInput]);

  return (
    <div
      className={classes.searchbar}
      style={{
        borderBottom: props.noBorder
          ? 'none'
          : localInput.length > 1
          ? 'solid 1.5px #3C419A'
          : 'solid 1px rgba(44, 45, 62, 0.1)',
      }}
    >
      <TooltipOne title={`Szukaj według wprowadzonej wartości`} placement="top">
        <IconButton
          disableRipple
          aria-label="Ikonka wyszukiwania w kolumnie tabeli"
          size="small"
          onClick={() => {
            inputRef.current && inputRef.current.focus();
          }}
          tabIndex={tabIndexForChildren}
        >
          <SearchIcon
            className={highContrastMode ? `${classes.searchIcon} ${classes.searchIconContrast}` : classes.searchIcon}
          />
        </IconButton>
      </TooltipOne>
      <InputBase
        style={{
          width: '65%',
          fontSize: '14px',
          color: highContrastMode ? fill : 'rgba(44, 45, 62, 0.8)',
        }}
        placeholder="..."
        value={localInput}
        inputProps={{ 'aria-label': 'Szukaj', tabIndex: props.tabIndex, ref: inputRef }}
        onChange={(event) => setLocalInput(event.target.value)}
        onFocus={() => setIsReadOnly(false)}
        onBlur={() => setIsReadOnly(true)}
        // setting as readonly when not focused to prevent autofilling like in https://dev.azure.com/dxccke/ONE/_workitems/edit/18357
        readOnly={isReadOnly}
      />
      {localInput && (
        <CloseIcon
          onClick={() => {
            setLocalInput('');
          }}
          onKeyPress={(event) => {
            if (event.key === 'Enter') {
              setLocalInput('');
            }
          }}
          className={classes.searchCloseIcon}
          tabIndex={tabIndexForChildren}
        />
      )}
    </div>
  );
};
